/**
 * Back Office Settlement = Batch Out through Aster Gateway.
 * The batch history and each terminal's verdict are Aster Gateway's own answers.
 */
import { useOutletContext } from 'react-router-dom';
import BatchOutPanel from '@/components/merchant/BatchOutPanel';

export default function SettlementPage() {
  const context = useOutletContext() || {};
  const { token = localStorage.getItem('backoffice_token'), activeRestaurantId, restaurant, manager } = context;
  const restaurantId = activeRestaurantId || restaurant?.id || manager?.restaurant_id;

  return (
    <div className="max-w-5xl mx-auto space-y-4" data-testid="settlement-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900 dark:text-white">Settlement</h1>
        <p className="text-sm text-slate-500">Batch out your card terminals and see every batch-out you requested.</p>
      </div>
      <BatchOutPanel token={token} restaurantId={restaurantId} />
    </div>
  );
}
